import
  React
from 'react';

import {
  Base,
  ColorSvg,
  HContainer,
  Text,
  VContainer
} from '@vodacom/web-common';

import {
  CustomColors,
  Icons
} from '../../../constants';

export const TwitterContent = props => {

  return (

    <Base
      padding='10px'>

      <HContainer>

        <Text
          fontWeight='bold'>

          {props.contentAccount}
        </Text>

        <Text
          color={CustomColors.Grey6}
          padding='0 0 0 3px'>

          {props.contentUsername}
        </Text>
      </HContainer>

      <VContainer>

        <Text>

          {`${props.contentTweet}`}
        </Text>

        <HContainer
          padding='10px 0 0 0'>

          <ColorSvg
            src={Icons.Heart}
            color={CustomColors.Grey8}
            width='20px'
            height='16px'/>

          <Text
            fontSize='12px'
            color={CustomColors.Grey7}
            padding='0 30px 0 0'>

            {props.contentLikes}
          </Text>

          <ColorSvg
            src={Icons.Retweet}
            color={CustomColors.Grey8}
            width='20px'
            height='16px'/>

          <Text
            fontSize='12px'
            color={CustomColors.Grey7}>

            {props.contentRetweets}
          </Text>

          <Base
            margin='0 0 0 auto'>

            <Text
              fontSize='12px'
              color={CustomColors.Grey6}>

              {props.contentDate}
            </Text>

          </Base>
        </HContainer>
      </VContainer>
    </Base>
  );
};